import {Observable} from 'rxjs';
import {Ticket} from '../model/ticket.model';

export abstract class CustomTicketsAdapter {
  abstract loadTicketCategories(): Observable<any>;

  abstract loadTicketCompanyCategories(): Observable<any>;

  abstract loadTicket(ticketId: string, userId: string): Observable<any>;

  abstract addTicket(ticket: Ticket, userId: string): Observable<any>;

  abstract loadTickets(userId: string, pageSize?: number,
                       currentPage?: number,
                       sort?: string): Observable<any>;
}
